webpackJsonp([70144966829960],{

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(293);

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var settle = __webpack_require__(299);
	var buildURL = __webpack_require__(302);
	var parseHeaders = __webpack_require__(308);
	var isURLSameOrigin = __webpack_require__(306);
	var createError = __webpack_require__(187);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(301);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(304);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var bind = __webpack_require__(188);
	var Axios = __webpack_require__(295);
	var defaults = __webpack_require__(110);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(185);
	axios.CancelToken = __webpack_require__(294);
	axios.isCancel = __webpack_require__(186);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(309);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(185);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(110);
	var utils = __webpack_require__(16);
	var InterceptorManager = __webpack_require__(296);
	var dispatchRequest = __webpack_require__(297);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(298);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	var transformData = __webpack_require__(300);
	var isCancel = __webpack_require__(186);
	var defaults = __webpack_require__(110);
	var isAbsoluteURL = __webpack_require__(305);
	var combineURLs = __webpack_require__(303);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(187);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(16);
	var normalizeHeaderName = __webpack_require__(307);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(184);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(184);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(16);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(188);
	var isBuffer = __webpack_require__(450);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(77);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(3);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(74);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(36);
	var isArguments = __webpack_require__(35);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	function dlv(t,e,n,l){for(l=0,e=e.split?e.split("."):e;t&&l<e.length;)t=t[e[l++]];return void 0===t?n:t}function linkState(t,e,n){var l=e.split("."),r=t.__lsc||(t.__lsc={});return r[e+n]||(r[e+n]=function(e){for(var r=e&&e.target||this,a={},i=a,o="string"==typeof n?dlv(e,n):r.nodeName?r.type.match(/^che|rad/)?r.checked:r.value:e,s=0;s<l.length-1;s++)i=i[l[s]]||(i[l[s]]=!s&&t.state[l[s]]||{});i[l[s]]=o,t.setState(a)})}module.exports=linkState;
	//# sourceMappingURL=linkstate.js.map


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(42);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(34);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(41);
	
	var _HelmetConstants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(37);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(43);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	function AsyncResolvers(onFailedOne, onResolvedAll) {
	  this.onResolvedAll = onResolvedAll;
	  this.onFailedOne = onFailedOne;
	  this.resolvers = {};
	  this.resolversCount = 0;
	  this.passed = [];
	  this.failed = [];
	  this.firing = false;
	}
	
	AsyncResolvers.prototype = {
	
	  /**
	   * Add resolver
	   *
	   * @param {Rule} rule
	   * @return {integer}
	   */
	  add: function(rule) {
	    var index = this.resolversCount;
	    this.resolvers[index] = rule;
	    this.resolversCount++;
	    return index;
	  },
	
	  /**
	   * Resolve given index
	   *
	   * @param  {integer} index
	   * @return {void}
	   */
	  resolve: function(index) {
	    var rule = this.resolvers[index];
	    if (rule.passes === true) {
	      this.passed.push(rule);
	    } else if (rule.passes === false) {
	      this.failed.push(rule);
	      this.onFailedOne(rule);
	    }
	
	    this.fire();
	  },
	
	  /**
	   * Determine if all have been resolved
	   *
	   * @return {boolean}
	   */
	  isAllResolved: function() {
	    return (this.passed.length + this.failed.length) === this.resolversCount;
	  },
	
	  /**
	   * Attempt to fire final all resolved callback if completed
	   *
	   * @return {void}
	   */
	  fire: function() {
	
	    if (!this.firing) {
	      return;
	    }
	
	    if (this.isAllResolved()) {
	      this.onResolvedAll(this.failed.length === 0);
	    }
	
	  },
	
	  /**
	   * Enable firing
	   *
	   * @return {void}
	   */
	  enableFiring: function() {
	    this.firing = true;
	  }
	
	};
	
	module.exports = AsyncResolvers;


/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	var replacements = {
	
	  /**
	   * Between replacement (replaces :min and :max)
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  between: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      min: parameters[0],
	      max: parameters[1]
	    });
	  },
	
	  /**
	   * Required_if replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_if: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      other: this._getAttributeName(parameters[0]),
	      value: parameters[1]
	    });
	  },
	
	  /**
	   * Required_unless replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_unless: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      other: this._getAttributeName(parameters[0]),
	      value: parameters[1]
	    });
	  },
	
	  /**
	   * Required_with replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_with: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      field: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * Required_with_all replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_with_all: function(template, rule) {
	    var parameters = rule.getParameters();
	    var getAttributeName = this._getAttributeName.bind(this);
	    return this._replacePlaceholders(rule, template, {
	      fields: parameters.map(getAttributeName).join(', ')
	    });
	  },
	
	  /**
	   * Required_without replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_without: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      field: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * Required_without_all replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  required_without_all: function(template, rule) {
	    var parameters = rule.getParameters();
	    var getAttributeName = this._getAttributeName.bind(this);
	    return this._replacePlaceholders(rule, template, {
	      fields: parameters.map(getAttributeName).join(', ')
	    });
	  },
	
	 /**
	   * After replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  after: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      after: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * Before replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  before: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      before: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * After_or_equal replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  after_or_equal: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      after_or_equal: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * Before_or_equal replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  before_or_equal: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      before_or_equal: this._getAttributeName(parameters[0])
	    });
	  },
	
	  /**
	   * Same replacement.
	   *
	   * @param  {string} template
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  same: function(template, rule) {
	    var parameters = rule.getParameters();
	    return this._replacePlaceholders(rule, template, {
	      same: this._getAttributeName(parameters[0])
	    });
	  },
	};
	
	function formatter(attribute) {
	  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
	}
	
	module.exports = {
	  replacements: replacements,
	  formatter: formatter
	};


/***/ }),

/***/ 618:
/***/ (function(module, exports) {

	var Errors = function() {
	  this.errors = {};
	};
	
	Errors.prototype = {
	  constructor: Errors,
	
	  /**
	   * Add new error message for given attribute
	   *
	   * @param  {string} attribute
	   * @param  {string} message
	   * @return {void}
	   */
	  add: function(attribute, message) {
	    if (!this.has(attribute)) {
	      this.errors[attribute] = [];
	    }
	
	    if (this.errors[attribute].indexOf(message) === -1) {
	      this.errors[attribute].push(message);
	    }
	  },
	
	  /**
	   * Returns an array of error messages for an attribute, or an empty array
	   *
	   * @param  {string} attribute A key in the data object being validated
	   * @return {array} An array of error messages
	   */
	  get: function(attribute) {
	    if (this.has(attribute)) {
	      return this.errors[attribute];
	    }
	
	    return [];
	  },
	
	  /**
	   * Returns the first error message for an attribute, false otherwise
	   *
	   * @param  {string} attribute A key in the data object being validated
	   * @return {string|false} First error message or false
	   */
	  first: function(attribute) {
	    if (this.has(attribute)) {
	      return this.errors[attribute][0];
	    }
	
	    return false;
	  },
	
	  /**
	   * Get all error messages from all failing attributes
	   *
	   * @return {Object} Failed attribute names for keys and an array of messages for values
	   */
	  all: function() {
	    return this.errors;
	  },
	
	  /**
	   * Determine if there are any error messages for an attribute
	   *
	   * @param  {string}  attribute A key in the data object being validated
	   * @return {boolean}
	   */
	  has: function(attribute) {
	    if (this.errors.hasOwnProperty(attribute)) {
	      return true;
	    }
	
	    return false;
	  }
	};
	
	module.exports = Errors;


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	var require;var Messages = __webpack_require__(621);
	
	__webpack_require__(181);
	
	var require_method = require;
	
	var container = {
	
	  messages: {},
	
	  /**
	   * Set messages for language
	   *
	   * @param {string} lang
	   * @param {object} rawMessages
	   * @return {void}
	   */
	  _set: function(lang, rawMessages) {
	    this.messages[lang] = rawMessages;
	  },
	
	  /**
	   * Set message for given language's rule.
	   *
	   * @param {string} lang
	   * @param {string} attribute
	   * @param {string|object} message
	   * @return {void}
	   */
	  _setRuleMessage: function(lang, attribute, message) {
	    this._load(lang);
	    if (message === undefined) {
	      message = this.messages[lang].def;
	    }
	
	    this.messages[lang][attribute] = message;
	  },
	
	  /**
	   * Load messages (if not already loaded)
	   *
	   * @param  {string} lang
	   * @return {void}
	   */
	  _load: function(lang) {
	    if (!this.messages[lang]) {
	      try {
	        var rawMessages = __webpack_require__(619)("./" + lang);
	        this._set(lang, rawMessages);
	      } catch (e) {}
	    }
	  },
	
	  /**
	   * Get raw messages for language
	   *
	   * @param  {string} lang
	   * @return {object}
	   */
	  _get: function(lang) {
	    this._load(lang);
	    return this.messages[lang];
	  },
	
	  /**
	   * Make messages for given language
	   *
	   * @param  {string} lang
	   * @return {Messages}
	   */
	  _make: function(lang) {
	    this._load(lang);
	    return new Messages(lang, this.messages[lang]);
	  }
	
	};
	
	module.exports = container;


/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Das :attribute Feld muss akzeptiert werden.',
	  after: 'Das :attribute muss ein Datum nach dem :after sein.',
	  after_or_equal: 'Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.',
	  alpha: 'Das :attribute Feld darf nur aus Buchstaben bestehen.',
	  alpha_dash: 'Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.',
	  alpha_num: 'Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.',
	  before: 'Das :attribute muss ein Datum vor dem :before sein.',
	  before_or_equal: 'Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.',
	  between: 'Das :attribute Feld muss zwischen :min und :max liegen.',
	  confirmed: 'Das :attribute Feld stimmt nicht mit der Bestätigung überein.',
	  email: 'Das :attribute Format ist ungültig.',
	  date: 'Das :attribute Feld muss ein gültiges Datum sein.',
	  def: 'Das :attribute Feld hat Fehler.',
	  digits: 'Das :attribute Feld muss :digits Stellen haben.',
	  different: 'Die Felder :attribute und :different müssen sich unterscheiden.',
	  'in': 'Der gewählte Wert für :attribute ist ungültig.',
	  integer: 'Das :attribute Feld muss eine ganze Zahl sein.',
	  min: {
	    numeric: 'Das :attribute Feld muss mindestens :min sein.',
	    string: 'Das :attribute Feld muss mindestens :min Zeichen lang sein.'
	  },
	  max: {
	    numeric: 'Das :attribute Feld darf maximal :max sein.',
	    string: 'Das :attribute Feld darf maximal :max Zeichen haben.'
	  },
	  not_in: 'Der gewählte Wert für :attribute ist ungültig.',
	  numeric: 'Das :attribute Feld muss eine Zahl sein.',
	  present: 'Das Feld :attribute muss vorhanden sein (kann aber leer sein).',
	  required: 'Das :attribute Feld muss ausgefüllt sein.',
	  required_if: 'Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.',
	  same: 'Die Felder :attribute und :same müssen übereinstimmen.',
	  size: {
	    numeric: 'Das :attribute Feld muss gleich :size sein.',
	    string: 'Das :attribute Feld muss :size Zeichen lang sein.'
	  },
	  string: 'Das :attribute Feld muss ein Satz sein.',
	  url: 'Das Format von :attribute ist ungültig.',
	  regex: 'Das :attribute Format ist ungültig.',
	  attributes: {}
	};


/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Το πεδίο :attribute πρέπει να γίνει αποδεκτό.',
	  after: 'Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.',
	  alpha: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.',
	  alpha_dash: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.',
	  alpha_num: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.',
	  between: 'Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.',
	  confirmed: 'Η επιβεβαίωση του :attribute δεν ταιριάζει.',
	  email: 'Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.',
	  date: 'Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.',
	  def: 'Το πεδίο :attribute περιέχει σφάλματα.',
	  digits: 'Το πεδίο :attribute πρέπει να είναι :digits ψηφία.',
	  different: 'Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.',
	  'in': 'Το επιλεγμένο :attribute δεν είναι έγκυρο.',
	  integer: 'Το πεδίο :attribute πρέπει να είναι ακέραιος.',
	  min: {
	    numeric: 'Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.',
	    string: 'Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες.'
	  },
	  max: {
	    numeric: 'Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.',
	    string: 'Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες.'
	  },
	  not_in: 'Το επιλεγμένο :attribute δεν είναι αποδεκτό.',
	  numeric: 'Το πεδίο :attribute πρέπει να είναι αριθμός.',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: 'Το πεδίο :attribute είναι απαραίτητο.',
	  required_if: 'Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.',
	  same: 'Τα πεδία :attribute και :same πρέπει να είναι ίδια.',
	  size: {
	    numeric: 'Το πεδίο :attribute πρέπει να είναι :size.',
	    string: 'Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες.'
	  },
	  string: 'Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.',
	  url: 'Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.',
	  regex: 'Η μορφή του :attribute δεν είναι αποδεκτή.',
	  attributes: {}
	};


/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'The :attribute must be accepted.',
	  after: 'The :attribute must be after :after.',
	  after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
	  alpha: 'The :attribute field must contain only alphabetic characters.',
	  alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
	  alpha_num: 'The :attribute field must be alphanumeric.',
	  before: 'The :attribute must be before :before.',
	  before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
	  between: 'The :attribute field must be between :min and :max.',
	  confirmed: 'The :attribute confirmation does not match.',
	  email: 'The :attribute format is invalid.',
	  date: 'The :attribute is not a valid date format.',
	  def: 'The :attribute attribute has errors.',
	  digits: 'The :attribute must be :digits digits.',
	  different: 'The :attribute and :different must be different.',
	  'in': 'The selected :attribute is invalid.',
	  integer: 'The :attribute must be an integer.',
	  min: {
	    numeric: 'The :attribute must be at least :min.',
	    string: 'The :attribute must be at least :min characters.'
	  },
	  max: {
	    numeric: 'The :attribute may not be greater than :max.',
	    string: 'The :attribute may not be greater than :max characters.'
	  },
	  not_in: 'The selected :attribute is invalid.',
	  numeric: 'The :attribute must be a number.',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: 'The :attribute field is required.',
	  required_if: 'The :attribute field is required when :other is :value.',
	  required_unless: 'The :attribute field is required when :other is not :value.',
	  required_with: 'The :attribute field is required when :field is not empty.',
	  required_with_all: 'The :attribute field is required when :fields are not empty.',
	  required_without: 'The :attribute field is required when :field is empty.',
	  required_without_all: 'The :attribute field is required when :fields are empty.',
	  same: 'The :attribute and :same fields must match.',
	  size: {
	    numeric: 'The :attribute must be :size.',
	    string: 'The :attribute must be :size characters.'
	  },
	  string: 'The :attribute must be a string.',
	  url: 'The :attribute format is invalid.',
	  regex: 'The :attribute format is invalid.',
	  attributes: {}
	};


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'El campo :attribute debe ser aceptado.',
	  after: 'El campo :attribute debe ser una fecha posterior a :after.',
	  alpha: 'El campo :attribute solo debe contener letras.',
	  alpha_dash: 'El campo :attribute solo debe contener letras, números y guiones.',
	  alpha_num: 'El campo :attribute solo debe contener letras y números.',
	  attributes: {},
	  between: 'El campo :attribute tiene que estar entre :min - :max.',
	  confirmed: 'La confirmación de :attribute no coincide.',
	  different: 'El campo :attribute y :other deben ser diferentes.',
	  digits: 'El campo :attribute debe tener :digits dígitos.',
	  email: 'El campo :attribute no es un correo válido.',
	  'in': 'El campo :attribute es inválido.',
	  integer: 'El campo :attribute debe ser un número entero.',
	  max: {
	    numeric: 'El campo :attribute no debe ser mayor a :max.',
	    string: 'El campo :attribute no debe ser mayor que :max caracteres.'
	  },
	  min: {
	    numeric: 'El tamaño del campo :attribute debe ser de al menos :min.',
	    string: 'El campo :attribute debe contener al menos :min caracteres.'
	  },
	  not_in: 'El campo :attribute es inválido.',
	  numeric: 'El campo :attribute debe ser numérico.',
	  present: 'El campo de :attribute debe estar presente (pero puede estar vacío).',
	  regex: 'El formato del campo :attribute es inválido.',
	  required: 'El campo :attribute es obligatorio.',
	  required_if: 'El campo :attribute es obligatorio cuando :other es :value.',
	  same: 'El campo :attribute y :other deben coincidir.',
	  size: {
	    numeric: 'El tamaño del campo :attribute debe ser :size.',
	    string: 'El campo :attribute debe contener :size caracteres.'
	  },
	  url: 'El formato de :attribute es inválido.'
	};


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'فیلد :attribute می بایست تایید شود',
	  alpha: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد',
	  alpha_dash: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد',
	  alpha_num: 'فیلد :attribute می بایست فقط شامل حروف و اعداد باشد',
	  between: 'فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد',
	  confirmed: 'تطبیق فیلد :attribute صحیح نمی باشد',
	  email: 'فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد',
	  date: 'تاریخ درج شده در فیلد :attribute صحیح نیست',
	  def: 'فیلد :attribute اشکال دارد',
	  digits: 'فیلد :attribute می بایست شامل :digits رقم باشد',
	  different: 'فیلد :attribute می بایست مقداری غیر از :different داشته باشد',
	  'in': 'فیلد :attribute انتخاب شده صحیح نمی باشد',
	  integer: 'فیلد :attribute می بایست عددی باشد',
	  min: {
	    numeric: 'فیلد :attribute می بایست از :min بزرگتر باشد',
	    string: 'فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد'
	  },
	  max: {
	    numeric: 'فیلد :attribute می بایست از :max کوچکتر باشد',
	    string: 'فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد'
	  },
	  not_in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
	  numeric: 'فیلد :attribute می بایست عددی باشد',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: 'فیلد :attribute الزامی است',
	  required_if: 'در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است',
	  same: 'فیلد :attribute می بایست با فیلد :same یکی باشد',
	  size: {
	    numeric: 'فیلد :attribute می بایست :size باشد',
	    string: 'فیلد :attribute می بایست :size کاراکتر طول داشته باشد'
	  },
	  string: 'فیلد :attribute می بایست متنی باشد',
	  url: 'آدرس فیلد :attribute صحیح نمی باشد',
	  regex: 'فرمت آدرس :attribute صحیح نمی باشد',
	  attributes: {}
	};


/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Le champ :attribute doit être accepté.',
	  alpha: 'Le champ :attribute ne peut contenir que des caractères alphabétiques.',
	  alpha_dash: 'Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.',
	  alpha_num: 'Le champ :attribute ne peut contenir que des caractères alphanumériques.',
	  between: 'La longueur du champ :attribute doit être comprise entre :min and :max.',
	  confirmed: 'Le champ :attribute n\'est pas confirmé.',
	  email: 'Le champ :attribute contient un format invalide.',
	  def: 'Le champ :attribute contient un attribut erroné.',
	  digits: 'Le champ :attribute doit être composé de :digits chiffres.',
	  different: 'Les champs :attribute et :different doivent être différents.',
	  'in': 'Le champ :attribute est invalide.',
	  integer: 'Le champ :attribute doit être un entier.',
	  min: {
	    numeric: 'Le champ :attribute doit être supérieur à :min.',
	    string: 'Le champ :attribute doit contenir plus de :min caractères.'
	  },
	  max: {
	    numeric: 'Le champ :attribute doit être inférieur à :max.',
	    string: 'Le champ :attribute doit contenir moins de :max caractères.'
	  },
	  not_in: 'Le champ :attribute est invalide.',
	  numeric: 'Le champ :attribute doit être un chiffre.',
	  present: 'Le champ :attribute doit être présent (mais peut être vide).',
	  required: 'Le champ :attribute est requis.',
	  required_if: 'Le champ :attribute est requis quand :other est :value.',
	  same: 'Les champs :attribute et :same doivent correspondre.',
	  size: {
	    numeric: 'Le champ :attribute doit être égal à :size.',
	    string: 'Le champ :attribute doit contenir :size caractères.'
	  },
	  url: 'Le format du champ :attribute est invalide.',
	  regex: 'Le format du champ :attribute est invalide.',
	  attributes: {}
	};


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Il campo :attribute deve essere accettato.',
	  alpha: 'Il campo :attribute deve contenere sono caratteri alfabetici.',
	  alpha_dash: 'Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.',
	  alpha_num: 'Il campo :attribute deve essere alfanumerico.',
	  between: 'Il campo :attribute deve essere compreso tra :min e :max.',
	  confirmed: 'Il campo conferma :attribute non è uguale.',
	  email: 'Il formato dell\'attributo :attribute non è valido.',
	  def: 'Gli attributi del campo :attribute contengono degli errori.',
	  digits: 'Il campo :attribute deve essere di :digits cifre.',
	  different: 'Il campo :attribute e :different devo essere diversi.',
	  'in': 'Il valore del campo :attribute non è valido.',
	  integer: 'Il campo :attribute deve essere un valore intero.',
	  min: {
	    numeric: 'Il campo :attribute deve essere maggiore o uguale di :min.',
	    string: 'Il campo :attribute deve essere composto da almeno :min caratteri.'
	  },
	  max: {
	    numeric: 'Il campo :attribute deve essere minore o uguale di :max.',
	    string: 'Il campo :attribute deve essere composto da massimo :max caratteri.'
	  },
	  not_in: 'Il campo :attribute non è valido.',
	  numeric: 'Il campo :attribute deve essere un numero.',
	  present: 'Il campo :attribute deve essere presente (ma può essere vuoto).',
	  required: 'Il campo :attribute è richiesto.',
	  required_if: 'Il campo :attribute è richiesto quando il campo :other è uguale a :value.',
	  same: 'I campi :attribute e :same devono essere uguali.',
	  size: {
	    numeric: 'La dimensione del campo :attribute deve essere uguale a :size.',
	    string: 'Il campo :attribute deve essere di :size caratteri.'
	  },
	  string: 'Il campo :attribute deve essere una stringa.',
	  url: 'Il formato del campo :attribute non è valido.',
	  regex: 'Il formato del campo :attribute non è valido.',
	  attributes: {}
	};


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	module.exports = {
	    accepted: ':attributeを確認してください。',
	    alpha: ':attributeは英字のみで入力してください。',
	    alpha_dash: ':attributeは英字とダッシュと下線のみで入力してください。',
	    alpha_num: ':attributeは英数字のみで入力してください。',
	    between: ':attributeは:min〜:max文字で入力してください。',
	    confirmed: ':attributeは確認が一致しません。',
	    email: ':attributeは正しいメールアドレスを入力してください。',
	    date: ':attributeは正しい日付形式を入力してください',
	    def: ':attributeは検証エラーが含まれています。',
	    digits: ':attributeは:digitsの数字のみで入力してください。',
	    different: ':attributeと:differentは同じであってはなりません。',
	    'in': '選択された:attributeは無効です。',
	    integer: ':attributeは整数で入力してください。',
	    min        : {
	        numeric : ":attributeは:min以上で入力してください。",
	        string  : ":attributeは:min文字以上で入力してください。"
	    },
	    max : {
	        numeric : ":attributeは:max以下で入力してください。",
	        string  : ":attributeは:max文字以下で入力してください。"
	    },
	    not_in      : "選択された:attributeは無効です。",
	    numeric     : ":attributeは数値で入力してください。",
	    present: 'The :attribute field must be present (but can be empty).',
	    required    : ":attributeは必須です。",
	    required_if : ":otherは:valueになったら:attributeは必須です。",
	    same        : ":attributeと:sameは同じでなければなりません。",
	    size        : {
	        numeric : ":attributeは:sizeを入力してください。",
	        string  : ":attributeは:size文字で入力してください。"
	    },
	    url        : ":attributeは正しいURIを入力してください。",
	    regex      : ":attributeの値 \":value\" はパターンにマッチする必要があります。",
	    attributes : {}
	};


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute må være akseptert.',
	  alpha: ':attribute feltet kan kun inneholde alfabetiske tegn.',
	  alpha_dash: ':attribute feltet kan kun inneholde alfanumeriske tegn, i tillegg til bindestreker og understreker.',
	  alpha_num: ':attribute feltet må være alfanumerisk.',
	  between: ':attribute feltet må være mellom :min og :max.',
	  confirmed: ':attribute feltet stemmer ikke overens med bekreftelsen.',
	  email: ':attribute formatet er ugyldig.',
	  date: ':attribute er et ugyldig datoformat.',
	  def: ':attribute attributtet har feil.',
	  digits: ':attribute må være på :digits siffer.',
	  different: ':attribute og :different må være forskjellige.',
	  'in': 'Den oppgitte verdien for :attribute er ugyldig.',
	  integer: ':attribute må være et heltall.',
	  min: {
	    numeric: ':attribute må minst være :min.',
	    string: ':attribute må være på minst :min tegn.'
	  },
	  max: {
	    numeric: ':attribute kan ikke være større enn :max.',
	    string: ':attribute kan maks ha :max tegn.'
	  },
	  'not_in': 'Den oppgitte verdien for :attribute er ugyldig.',
	  numeric: ':attribute må være et tall.',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: ':attribute feltet er påkrevd.',
	  required_if: ':attribute er påkrevd når :other er :value.',
	  same: ':attribute og :same må være like.',
	  size: {
	    numeric: ':attribute må ha størrelsen :size.',
	    string: ':attribute må ha :size tegn.'
	  },
	  string: ':attribute må være tekst.',
	  url: ':attribute formatet er ugyldig.',
	  regex: ':attribute formatet er ugyldig.',
	  attributes: {}
	};


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Het :attribute veld moet geaccepteerd worden.',
	  after: ':attribute moet een datum na :after zijn.',
	  after_or_equal: 'De :attribute datum moet op of na :after_or_equal zijn.',
	  alpha: 'Het :attribute veld mag alleen maar letters bevatten.',
	  alpha_dash: 'Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.',
	  alpha_num: 'Het :attribute veld mag alleen maar letters en cijfers bevatten.',
	  before: ':attribute moet vòòr :before zijn.',
	  before_or_equal: ':attribute moet vòòr of op :before_or_equal zijn.',
	  between: 'Het :attribute veld moet tussen :min en :max liggen.',
	  confirmed: 'Het :attribute veld komt niet met de bevestiging overeen.',
	  email: 'Het :attribute formaat is ongeldig.',
	  date: 'Het :attribute veld moet een geldige datum zijn.',
	  def: 'Het :attribute veld bevat fouten.',
	  digits: 'Het :attribute veld moet :digits cijfers hebben.',
	  different: 'Het :attribute en :different veld moeten verschillend zijn.',
	  'in': 'De gekozen waarde voor :attribute is ongeldig.',
	  integer: 'Het :attribute veld moet een geheel getal zijn.',
	  min: {
	    numeric: 'Het :attribute veld moet minstens :min zijn.',
	    string: 'Het :attribute veld moet minstens :min karakters bevatten.'
	  },
	  max: {
	    numeric: 'Het :attribute veld mag maximaal :max zijn.',
	    string: 'Het :attribute veld mag niet meer dan :max karakters bevatten.'
	  },
	  not_in: 'De gekozen waarde voor :attribute is ongeldig.',
	  numeric: 'Het :attribute veld moet een getal zijn.',
	  present: 'Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).',
	  required: 'Het :attribute veld moet ingevuld zijn.',
	  required_if: 'Het :attribute veld moet ingevuld zijn, wanneer :other :value is.',
	  required_unless: 'Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.',
	  required_with: 'Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.',
	  required_with_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.',
	  required_without: 'Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.',
	  required_without_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.',
	  same: 'De :attribute en :same velden moeten overeenkomen.',
	  size: {
	    numeric: 'Het :attribute veld moet :size zijn.',
	    string: 'Het :attribute veld moet :size karakters bevatten.'
	  },
	  string: 'Het :attribute veld moet een woord of zin zijn.',
	  url: 'Het :attribute veld heeft een ongeldig formaat.',
	  regex: 'Het :attribute veld heeft een ongeldig formaat.',
	  attributes: {}
	};


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	module.exports = {
	    accepted: 'Pole :attribute musi być zaakceptowane.',
	    alpha: 'Pole :attribute może zawierać tylko litery.',
	    alpha_dash: 'Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.',
	    alpha_num: 'Pole :attribute moze zawierac tylko znaki alfanumeryczne.',
	    between: 'Pole :attribute musi mieć długość od :min do :max.',
	    confirmed: 'Pole :attribute nie spełnia warunku potwierdzenia.',
	    email: 'Pole :attribute ma niepoprawny format adresu email.',
	    date: 'Pole :attribute musi mieć poprawny format daty.',
	    def: 'Pole :attribute zawiera błędy.',
	    digits: 'Pole :attribute może zawierać tylko cyfry ze zbioru :digits.',
	    different: 'Pola :attribute i :different muszą się różnić.',
	    'in': 'Pole :attribute musi należeć do zbioru :in.',
	    integer: 'Pole :attribute musi być liczbą całkowitą.',
	    min: {
	        numeric: 'Pole :attribute musi być równe conajmniej :min.',
	        string: 'Pole :attribute musi zawierać conajmniej :min znaków.'
	    },
	    max: {
	        numeric: 'Pole :attribute nie moze być większe :max.',
	        string: 'Pole :attribute nie moze być dłuższe niż :max znaków.'
	    },
	    not_in: 'Pole :attribute nie może należeć do zbioru :not_in.',
	    numeric: 'Pole :attribute musi być liczbą.',
	    present: 'Polu :attribute musi być obecny (ale może być pusta).',
	    required: 'Pole :attribute jest wymagane.',
	    required_if: 'Pole :attribute jest wymagane jeśli pole :other jest równe :value.',
	    same: 'Pola :attribute i :same muszą być takie same.',
	    size: {
	        numeric: 'Pole :attribute musi być równe :size.',
	        string: 'Pole :attribute musi zawierać :size znaków.'
	    },
	    string: 'Pole :attribute musi być ciągiem znaków.',
	    url: 'Pole :attribute musi być poprawnym adresem URL.',
	    regex: 'Pole :attribute nie spełnia warunku.',
	    attributes: {}
	};


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'O :attribute precisa ser aceito.',
	  alpha: 'O campo :attribute só pode conter letras.',
	  alpha_dash: 'O campo :attribute só pode conter letras, números, hífens e sublinha.',
	  alpha_num: 'O campo :attribute só pode conter letras e números.',
	  between: 'O campo :attribute precisa estar entre :min e :max.',
	  confirmed: 'A confirmação de :attribute não coincide.',
	  email: 'O formato de :attribute é inválido.',
	  date: 'O :attribute não é um formato de data válido',
	  def: 'O atributo :attribute contém erros.',
	  digits: 'O atributo :attribute precisa ter :digits dígitos.',
	  different: 'O :attribute e :different precisam ser diferentes.',
	  'in': 'O atributo selecionado :attribute é inválido.',
	  integer: 'O :attribute precisa ser um inteiro.',
	  min: {
	    numeric: 'O :attribute precisa ser no mínimo :min.',
	    string: 'O :attribute precisa ter no mínimo :min caracteres.'
	  },
	  max: {
	    numeric: 'O :attribute não pode ser maior que :max.',
	    string: 'O :attribute não pode ter mais que :max caracteres.'
	  },
	  not_in: 'O :attribute selecionado é inválido.',
	  numeric: 'O :attribute precisa ser um número.',
	  present: 'O campo :attribute deve estar presente (mas pode estar vazio).',
	  required: 'O campo :attribute é obrigatório.',
	  required_if: 'O campo :attribute é obrigatório quando :other é :value.',
	  same: 'Os campos :attribute e :same precisam ser iguais.',
	  size: {
	    numeric: 'O :attribute precisa ser :size.',
	    string: 'O :attribute precisa ter :size caracteres.'
	  },
	  string: 'O :attribute precisa ser uma palavra.',
	  url: 'O formato de :attribute é inválido.',
	  regex: 'O formato de :attribute é inválido.',
	  attributes: {}
	};


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 273,
		"./de.js": 273,
		"./el": 274,
		"./el.js": 274,
		"./en": 181,
		"./en.js": 181,
		"./es": 275,
		"./es.js": 275,
		"./fa": 276,
		"./fa.js": 276,
		"./fr": 277,
		"./fr.js": 277,
		"./it": 278,
		"./it.js": 278,
		"./ja": 279,
		"./ja.js": 279,
		"./nb_NO": 280,
		"./nb_NO.js": 280,
		"./nl": 281,
		"./nl.js": 281,
		"./pl": 282,
		"./pl.js": 282,
		"./pt": 283,
		"./pt.js": 283,
		"./ru": 284,
		"./ru.js": 284,
		"./tr": 285,
		"./tr.js": 285,
		"./ua": 286,
		"./ua.js": 286,
		"./vi": 287,
		"./vi.js": 287,
		"./zh": 288,
		"./zh.js": 288,
		"./zh_TW": 289,
		"./zh_TW.js": 289
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 619;


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: 'Вы должны принять :attribute.',
	  alpha: 'Поле :attribute может содержать только буквы.',
	  alpha_dash: 'Поле :attribute может содержать только буквы, цифры, дефисы и символы подчёркивания.',
	  alpha_num: 'Поле :attribute может содержать только буквы и цифры.',
	  between: 'Поле :attribute должно быть между :min и :max.',
	  confirmed: 'Поле :attribute не совпадает с подтверждением.',
	  email: 'Поле :attribute должно быть действительным электронным адресом.',
	  def: 'Поле :attribute содержит ошибки.',
	  digits: 'Длина цифрового поля :attribute должна быть :digits.',
	  different: 'Поля :attribute и :different должны различаться.',
	  'in': 'Выбранное значение для :attribute ошибочно.',
	  integer: 'Поле :attribute должно быть целым числом.',
	  min: {
	    numeric: 'Значение поля :attribute должно быть больше или равно :min.',
	    string: 'Количество символов в поле :attribute должно быть не менее :min.'
	  },
	  max: {
	    numeric: 'Значение поля :attribute должно быть меньше или равно :max.',
	    string: 'Количество символов в поле :attribute не может превышать :max.'
	  },
	  not_in: 'Выбранное значение для :attribute ошибочно.',
	  numeric: 'Поле :attribute должно быть числом.',
	  present: 'Поле :attribute должно присутствовать (но может быть пустым).',
	  required: 'Поле :attribute обязательно для заполнения.',
	  required_if: 'Поле :attribute требуется когда значения поля :other равно :value.',
	  same: 'Значение :attribute должно совпадать с :same.',
	  size: {
	    numeric: 'Значение поля :attribute должно быть равным :size.',
	    string: 'Количество символов в поле :attribute должно быть равно :size.'
	  },
	  url: 'Поле :attribute должно содержать валидный URL.',
	  regex: 'Неверный формат поля :attribute.',
	  attributes: {}
	};


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute kabul edilmeli.',
	  alpha: ':attribute alanı sadece harflerden oluşabilir.',
	  alpha_dash: ':attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.',
	  alpha_num: ':attribute alanı alfa-nümerik olmalıdır.',
	  between: ':attribute alanı :min ile :max arasında olabilir.',
	  confirmed: ':attribute uyuşmuyor.',
	  email: ':attribute formatı geçersiz.',
	  date: ':attribute geöerli bir tarih alanı değil.',
	  def: ':attribute hatalar içeriyor.',
	  digits: ':attribute sadece rakamlardan oluşabilir.',
	  different: ':attribute ve :different farklı olmalı.',
	  'in': 'Seçilen :attribute geçerli değil.',
	  integer: ':attribute tam sayı olmalı.',
	  min: {
	    numeric: ':attribute en az :min olmalı.',
	    string: ':attribute en az :min karakter uzunluğunda olmalı.'
	  },
	  max: {
	    numeric: ':attribute en çok :max olabilir.',
	    string: ':attribute uzunluğu en çok :max karakter uzunluğunda olabilir.'
	  },
	  not_in: 'Seçilen :attribute geçerli değil.',
	  numeric: ':attribute sayı olmalı.',
	  present: ':attribute alanı bulunmalıdır (ancak boş olabilir).',
	  required: ':attribute alanı gerekli.',
	  required_if: ':attribute alanı :other alanı :value olduğunda gerekli.',
	  same: ':attribute ve :same aynı olmalı.',
	  size: {
	    numeric: ':attribute :size olmalı.',
	    string: ':attribute :size karakter uzunluğunda olmalı.'
	  },
	  string: ':attribute alfa-numerik olmalı.',
	  url: ':attribute formatı geçersiz.',
	  regex: ':attribute formatı geçersiz.',
	  attributes: {}
	};


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute повиннен бути прийнятий.',
	  alpha: 'Поле :attribute може складатись тільки з літер.',
	  alpha_dash: 'Поле :attribute може складатись тільки з літер, чисел, дефісів та символів підкреслення.',
	  alpha_num: 'Поле :attribute може складатись тільки з літер та чисел.',
	  between: 'Значення поля :attribute повинно знаходитись між :min і :max.',
	  confirmed: 'Поле :attribute не співпадає з підтвердженням.',
	  email: 'Значення поля :attribute повинно бути існуючою електронною адресою.',
	  def: 'Поле :attribute містить помилки.',
	  digits: 'Довжина числового поля :attribute повинна бути :digits.',
	  different: 'Поля :attribute і :different повинні відрізнятись.',
	  'in': 'Обране значення для :attribute помилкове.',
	  integer: 'Значення поля :attribute повинно бути цілим числом.',
	  min: {
	    numeric: 'Значення поля :attribute повинно бути більшим або рівним :min.',
	    string: 'Кількість символів в полі :attribute повинна бути не менше :min.'
	  },
	  max: {
	    numeric: 'Значення поля :attribute повинно бути менше або рівне :max.',
	    string: 'Кількість символів в полі :attribute не може превищувати :max.'
	  },
	  not_in: 'Обране значення для :attribute помилкове.',
	  numeric: 'Значення поля :attribute повинно бути числом.',
	  present: 'Поле :attribute повинно бути присутнім (але може бути пустим).',
	  required: 'Поле :attribute обов\'язкове для заповнення.',
	  required_if: 'Поле :attribute потрібне у випадку коли значення поля :other рівне :value.',
	  same: 'Значеня поля :attribute повинно співпадати з :same.',
	  size: {
	    numeric: 'Значення поля :attribute повинно бути рівним :size.',
	    string: 'Кількість символів в полі :attribute повинна бути рівною :size.'
	  },
	  url: 'Поле :attribute повинне містити валідний URL.',
	  regex: 'Неправильний формат значення :attribute.',
	  attributes: {}
	};


/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute phải được chấp nhận.',
	  alpha: 'Trường :attribute phải là ký tự',
	  alpha_dash: ':attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.',
	  alpha_num: ':attribute phải là ký tự chữ cái hoặc chữ số.',
	  between: ':attribute phải nằm trong khoảng :min và :max.',
	  confirmed: ':attribute xác nhận không trùng khớp.',
	  email: ':attribute không phải là email.',
	  date: ':attribute không phải là ngày hợp lệ',
	  def: 'Thuộc tính :attribute có lỗi.',
	  digits: ':attribute phải là số và có chiều dài bằng :digits.',
	  different: 'Giá trị của hai trường :attribute và :different phải khác nhau.',
	  'in': 'Giá trị được chọn của :attribute không hợp lệ.',
	  integer: ':attribute phải là số nguyên.',
	  min: {
	    numeric: ':attribute phải lớn hơn hoặc bằng :min.',
	    string: ':attribute phải có ít nhất :min ký tự.'
	  },
	  max: {
	    numeric: ':attribute phải nhỏ hơn hoặc bằng :max.',
	    string: ':attribute phải có ít hơn :max ký tự.'
	  },
	  not_in: 'Giá trị được chọn của trường :attribute không hợp lệ.',
	  numeric: ':attribute phải là số.',
	  present: 'Trường :attribute phải có mặt (nhưng có thể để trống).',
	  required: ':attribute bắt buộc nhập.',
	  required_if: ':attribute là bắt buộc khi :other có giá trị :value.',
	  same: 'Giá trị của :attribute và :same phải như nhau.',
	  size: {
	    numeric: ':attribute phải có chiều dài của bằng :size.',
	    string: 'Số ký tự của :attribute phải là :size ký tự.'
	  },
	  string: ':attribute không phải là một chuỗi',
	  url: ':attribute không phải là một Url hợp lệ.',
	  regex: ':attribute không đúng định dạng',
	  attributes: {}
	};


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute必须是可接受的.',
	  alpha: ':attribute只能包含字母.',
	  alpha_dash: ':attribute只能包含字母,连字符和下划线.',
	  alpha_num: ':attribute只能包含字母和数字.',
	  between: ':attribute的(大小,长度等)只能在:min和:max之间.',
	  confirmed: ':attribute确认不一致.',
	  email: ':attribute格式不正确.',
	  date: ':attribute日期格式错误.',
	  def: ':attribute属性错误.',
	  digits: ':attribute必须是:digits位小数.',
	  different: ':attribute和:different必须不同.',
	  'in': '选择的:attribute无效',
	  integer: ':attribute必须是一个整数.',
	  min: {
	    numeric: ':attribute不能小于:min.',
	    string: ':attribute长度不能小于:min.'
	  },
	  max: {
	    numeric: ':attribute不能大于:max.',
	    string: ':attribute长度不能大于:max.'
	  },
	  not_in: '所选的:attribute无效.',
	  numeric: ':attribute必须是一个数字.',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: ':attribute不能为空.',
	  required_if: '当:other是:value时,:attribute不能为空.',
	  same: ':attribute和:same必须一致.',
	  size: {
	    numeric: ':attribute必须等于:size.',
	    string: ':attribute的长度必须等于:size.'
	  },
	  string: ':attribute必须是一个字符串.',
	  url: ':attribute格式不正确.',
	  regex: ':attribute格式不正确.',
	  attributes: {}
	};


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	module.exports = {
	  accepted: ':attribute必須接受。',
	  alpha: ':attribute只能包含字母。',
	  alpha_dash: ':attribute只能包含字母，連字符和下划線。',
	  alpha_num: ':attribute只能包含字母和數字。',
	  between: ':attribute的值只能在:min和:max之間。',
	  confirmed: ':attribute與確認輸入不一致。',
	  email: ':attribute的格式錯誤。',
	  date: ':attribute的日期格式錯誤。',
	  def: ':attribute屬性錯誤。',
	  digits: ':attribute必須是:digits位小數。',
	  different: ':attribute和:different必須不同。',
	  'in': '選擇的:attribute無效',
	  integer: ':attribute必須是一個整數。',
	  min: {
	    numeric: ':attribute不能小於:min。',
	    string: ':attribute的長度不能小於:min.'
	  },
	  max: {
	    numeric: ':attribute不能大於:max。',
	    string: ':attribute的長度不能大於:max.'
	  },
	  not_in: '所選的:attribute無效。',
	  numeric: ':attribute必須是一個數字。',
	  present: 'The :attribute field must be present (but can be empty).',
	  required: ':attribute不能空白。',
	  required_if: '當:other是:value時,:attribute不能空白。',
	  same: ':attribute和:same必須一致。',
	  size: {
	    numeric: ':attribute必須等於:size。',
	    string: ':attribute的長度必須等於:size.'
	  },
	  string: ':attribute必須是一個字串。',
	  url: ':attribute格式不正確。',
	  regex: ':attribute格式不正確。',
	  attributes: {}
	};


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	var Attributes = __webpack_require__(272);
	
	var Messages = function(lang, messages) {
	  this.lang = lang;
	  this.messages = messages;
	  this.customMessages = {};
	  this.attributeNames = {};
	};
	
	Messages.prototype = {
	  constructor: Messages,
	
	  /**
	   * Set custom messages
	   *
	   * @param {object} customMessages
	   * @return {void}
	   */
	  _setCustom: function(customMessages) {
	    this.customMessages = customMessages || {};
	  },
	
	  /**
	   * Set custom attribute names.
	   *
	   * @param {object} attributes
	   */
	  _setAttributeNames: function(attributes) {
	    this.attributeNames = attributes;
	  },
	
	  /**
	   * Set the attribute formatter.
	   *
	   * @param {fuction} func
	   * @return {void}
	   */
	  _setAttributeFormatter: function(func) {
	    this.attributeFormatter = func;
	  },
	
	  /**
	   * Get attribute name to display.
	   *
	   * @param  {string} attribute
	   * @return {string}
	   */
	  _getAttributeName: function(attribute) {
	    var name = attribute;
	    if (this.attributeNames.hasOwnProperty(attribute)) {
	      return this.attributeNames[attribute];
	    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
	      name = this.messages.attributes[attribute];
	    }
	
	    if (this.attributeFormatter) {
	      name = this.attributeFormatter(name);
	    }
	
	    return name;
	  },
	
	  /**
	   * Get all messages
	   *
	   * @return {object}
	   */
	  all: function() {
	    return this.messages;
	  },
	
	  /**
	   * Render message
	   *
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  render: function(rule) {
	    if (rule.customMessage) {
	      return rule.customMessage;
	    }
	    var template = this._getTemplate(rule);
	
	    var message;
	    if (Attributes.replacements[rule.name]) {
	      message = Attributes.replacements[rule.name].apply(this, [template, rule]);
	    } else {
	      message = this._replacePlaceholders(rule, template, {});
	    }
	
	    return message;
	  },
	
	  /**
	   * Get the template to use for given rule
	   *
	   * @param  {Rule} rule
	   * @return {string}
	   */
	  _getTemplate: function(rule) {
	
	    var messages = this.messages;
	    var template = messages.def;
	    var customMessages = this.customMessages;
	    var formats = [rule.name + '.' + rule.attribute, rule.name];
	
	    for (var i = 0, format; i < formats.length; i++) {
	      format = formats[i];
	      if (customMessages.hasOwnProperty(format)) {
	        template = customMessages[format];
	        break;
	      } else if (messages.hasOwnProperty(format)) {
	        template = messages[format];
	        break;
	      }
	    }
	
	    if (typeof template === 'object') {
	      template = template[rule._getValueType()];
	    }
	
	    return template;
	  },
	
	  /**
	   * Replace placeholders in the template using the data object
	   *
	   * @param  {Rule} rule
	   * @param  {string} template
	   * @param  {object} data
	   * @return {string}
	   */
	  _replacePlaceholders: function(rule, template, data) {
	    var message, attribute;
	
	    data.attribute = this._getAttributeName(rule.attribute);
	    data[rule.name] = data[rule.name] || rule.getParameters().join(',');
	
	    if (typeof template === 'string' && typeof data === 'object') {
	      message = template;
	
	      for (attribute in data) {
	        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
	      }
	    }
	
	    return message;
	  }
	
	};
	
	module.exports = Messages;


/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	function leapYear(year) {
	  return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
	}
	
	function isValidDate(inDate) {
	    var valid = true;
	
	    // reformat if supplied as mm.dd.yyyy (period delimiter)
	    if (typeof inDate === 'string') {
	      var pos = inDate.indexOf('.');
	      if ((pos > 0 && pos <= 6)) {
	        inDate = inDate.replace(/\./g, '-');
	      }
	    }
	
	    var testDate = new Date(inDate);
	    var yr = testDate.getFullYear();
	    var mo = testDate.getMonth();
	    var day = testDate.getDate();
	
	    var daysInMonth = [31, (leapYear(yr) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	    if (yr < 1000) { return false; }
	    if (isNaN(mo)) { return false; }
	    if (mo + 1 > 12) { return false; }
	    if (isNaN(day)) { return false; }
	    if (day > daysInMonth[mo]) { return false; }
	
	    return valid;
	}
	
	var rules = {
	
	  required: function(val) {
	    var str;
	
	    if (val === undefined || val === null) {
	      return false;
	    }
	
	    str = String(val).replace(/\s/g, "");
	    return str.length > 0 ? true : false;
	  },
	
	  required_if: function(val, req, attribute) {
	    req = this.getParameters();
	    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
	      return this.validator.getRule('required').validate(val);
	    }
	
	    return true;
	  },
	
	  required_unless: function(val, req, attribute) {
	    req = this.getParameters();
	    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
	      return this.validator.getRule('required').validate(val);
	    }
	
	    return true;
	  },
	
	  required_with: function(val, req, attribute) {
	    if (this.validator._objectPath(this.validator.input, req)) {
	      return this.validator.getRule('required').validate(val);
	    }
	
	    return true;
	  },
	
	  required_with_all: function(val, req, attribute) {
	
	    req = this.getParameters();
	
	    for(var i = 0; i < req.length; i++) {
	      if (!this.validator._objectPath(this.validator.input, req[i])) {
	        return true;
	      }
	    }
	
	    return this.validator.getRule('required').validate(val);
	  },
	
	  required_without: function(val, req, attribute) {
	
	    if (this.validator._objectPath(this.validator.input, req)) {
	      return true;
	    }
	
	    return this.validator.getRule('required').validate(val);
	  },
	
	  required_without_all: function(val, req, attribute) {
	
	    req = this.getParameters();
	
	    for(var i = 0; i < req.length; i++) {
	      if (this.validator._objectPath(this.validator.input, req[i])) {
	        return true;
	      }
	    }
	
	    return this.validator.getRule('required').validate(val);
	  },
	
	  'boolean': function (val) {
	    return (
	      val === true ||
	      val === false ||
	      val === 0 ||
	      val === 1 ||
	      val === '0' ||
	      val === '1' ||
	      val === 'true' ||
	      val === 'false'
	    );
	  },
	
	  // compares the size of strings
	  // with numbers, compares the value
	  size: function(val, req, attribute) {
	    if (val) {
	      req = parseFloat(req);
	
	      var size = this.getSize();
	
	      return size === req;
	    }
	
	    return true;
	  },
	
	  string: function(val, req, attribute) {
	    return typeof val === 'string';
	  },
	
	  sometimes: function(val) {
	    return true;
	  },
	
	  /**
	   * Compares the size of strings or the value of numbers if there is a truthy value
	   */
	  min: function(val, req, attribute) {
	    var size = this.getSize();
	    return size >= req;
	  },
	
	  /**
	   * Compares the size of strings or the value of numbers if there is a truthy value
	   */
	  max: function(val, req, attribute) {
	    var size = this.getSize();
	    return size <= req;
	  },
	
	  between: function(val, req, attribute) {
	    req = this.getParameters();
	    var size = this.getSize();
	    var min = parseFloat(req[0], 10);
	    var max = parseFloat(req[1], 10);
	    return size >= min && size <= max;
	  },
	
	  email: function(val) {
	    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(val);
	  },
	
	  numeric: function(val) {
	    var num;
	
	    num = Number(val); // tries to convert value to a number. useful if value is coming from form element
	
	    if (typeof num === 'number' && !isNaN(num) && typeof val !== 'boolean') {
	      return true;
	    } else {
	      return false;
	    }
	  },
	
	  array: function(val) {
	    return val instanceof Array;
	  },
	
	  url: function(url) {
	    return (/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i).test(url);
	  },
	
	  alpha: function(val) {
	    return (/^[a-zA-Z]+$/).test(val);
	  },
	
	  alpha_dash: function(val) {
	    return (/^[a-zA-Z0-9_\-]+$/).test(val);
	  },
	
	  alpha_num: function(val) {
	    return (/^[a-zA-Z0-9]+$/).test(val);
	  },
	
	  same: function(val, req) {
	    var val1 = this.validator._flattenObject(this.validator.input)[req];
	    var val2 = val;
	
	    if (val1 === val2) {
	      return true;
	    }
	
	    return false;
	  },
	
	  different: function(val, req) {
	    var val1 = this.validator._flattenObject(this.validator.input)[req];
	    var val2 = val;
	
	    if (val1 !== val2) {
	      return true;
	    }
	
	    return false;
	  },
	
	  "in": function(val, req) {
	    var list, i;
	
	    if (val) {
	      list = this.getParameters();
	    }
	
	    if (val && !(val instanceof Array)) {
	      var localValue = val;
	
	      for (i = 0; i < list.length; i++) {
	        if (typeof list[i] === 'string') {
	          localValue = String(val);
	        }
	
	        if (localValue === list[i]) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    if (val && val instanceof Array) {
	      for (i = 0; i < val.length; i++) {
	        if (list.indexOf(val[i]) < 0) {
	          return false;
	        }
	      }
	    }
	
	    return true;
	  },
	
	  not_in: function(val, req) {
	    var list = this.getParameters();
	    var len = list.length;
	    var returnVal = true;
	
	    for (var i = 0; i < len; i++) {
	      var localValue = val;
	
	      if (typeof list[i] === 'string') {
	        localValue = String(val);
	      }
	
	      if (localValue === list[i]) {
	        returnVal = false;
	        break;
	      }
	    }
	
	    return returnVal;
	  },
	
	  accepted: function(val) {
	    if (val === 'on' || val === 'yes' || val === 1 || val === '1' || val === true) {
	      return true;
	    }
	
	    return false;
	  },
	
	  confirmed: function(val, req, key) {
	    var confirmedKey = key + '_confirmation';
	
	    if (this.validator.input[confirmedKey] === val) {
	      return true;
	    }
	
	    return false;
	  },
	
	  integer: function(val) {
	    return String(parseInt(val, 10)) === String(val);
	  },
	
	  digits: function(val, req) {
	    var numericRule = this.validator.getRule('numeric');
	    if (numericRule.validate(val) && String(val).length === parseInt(req)) {
	      return true;
	    }
	
	    return false;
	  },
	
	  regex: function(val, req) {
	    var mod = /[g|i|m]{1,3}$/;
	    var flag = req.match(mod);
	    flag = flag ? flag[0] : "";
	    req = req.replace(mod, "").slice(1, -1);
	    req = new RegExp(req, flag);
	    return !!val.match(req);
	  },
	
	  date: function(val, format) {
	    return isValidDate(val);
	  },
	
	  present: function(val) {
	    return typeof val !== 'undefined';
	  },
	
	  after: function(val, req){
	    var val1 = this.validator.input[req];
	    var val2 = val;
	
	    if(!isValidDate(val1)){ return false;}
	    if(!isValidDate(val2)){ return false;}
	
	    if (new Date(val1).getTime() < new Date(val2).getTime()) {
	      return true;
	    }
	
	    return false;
	  },
	
	   after_or_equal: function(val, req){
	    var val1 = this.validator.input[req];
	    var val2 = val;
	
	    if(!isValidDate(val1)){ return false;}
	    if(!isValidDate(val2)){ return false;}
	
	    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
	      return true;
	    }
	
	    return false;
	  },
	
	  before: function(val, req){
	    var val1 = this.validator.input[req];
	    var val2 = val;
	
	    if(!isValidDate(val1)){ return false;}
	    if(!isValidDate(val2)){ return false;}
	
	    if (new Date(val1).getTime() > new Date(val2).getTime()) {
	      return true;
	    }
	
	    return false;
	  },
	
	   before_or_equal: function(val, req){
	    var val1 = this.validator.input[req];
	    var val2 = val;
	
	    if(!isValidDate(val1)){ return false;}
	    if(!isValidDate(val2)){ return false;}
	
	    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
	      return true;
	    }
	
	    return false;
	  }
	
	
	};
	
	var missedRuleValidator = function() {
	  throw new Error('Validator `' + this.name + '` is not defined!');
	};
	var missedRuleMessage;
	
	function Rule(name, fn, async) {
	  this.name = name;
	  this.fn = fn;
	  this.passes = null;
	  this._customMessage = undefined;
	  this.async = async;
	}
	
	Rule.prototype = {
	
	  /**
	   * Validate rule
	   *
	   * @param  {mixed} inputValue
	   * @param  {mixed} ruleValue
	   * @param  {string} attribute
	   * @param  {function} callback
	   * @return {boolean|undefined}
	   */
	  validate: function(inputValue, ruleValue, attribute, callback) {
	    var _this = this;
	    this._setValidatingData(attribute, inputValue, ruleValue);
	    if (typeof callback === 'function') {
	      this.callback = callback;
	      var handleResponse = function(passes, message) {
	        _this.response(passes, message);
	      };
	
	      if (this.async) {
	        return this._apply(inputValue, ruleValue, attribute, handleResponse);
	      } else {
	        return handleResponse(this._apply(inputValue, ruleValue, attribute));
	      }
	    }
	    return this._apply(inputValue, ruleValue, attribute);
	  },
	
	  /**
	   * Apply validation function
	   *
	   * @param  {mixed} inputValue
	   * @param  {mixed} ruleValue
	   * @param  {string} attribute
	   * @param  {function} callback
	   * @return {boolean|undefined}
	   */
	  _apply: function(inputValue, ruleValue, attribute, callback) {
	    var fn = this.isMissed() ? missedRuleValidator : this.fn;
	
	    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
	  },
	
	  /**
	   * Set validating data
	   *
	   * @param {string} attribute
	   * @param {mixed} inputValue
	   * @param {mixed} ruleValue
	   * @return {void}
	   */
	  _setValidatingData: function(attribute, inputValue, ruleValue) {
	    this.attribute = attribute;
	    this.inputValue = inputValue;
	    this.ruleValue = ruleValue;
	  },
	
	  /**
	   * Get parameters
	   *
	   * @return {array}
	   */
	  getParameters: function() {
	    var value = [];
	
	    if (typeof this.ruleValue === 'string') {
	      value = this.ruleValue.split(',');
	    }
	
	    if (typeof this.ruleValue === 'number') {
	      value.push(this.ruleValue);
	    }
	
	    if (this.ruleValue instanceof Array) {
	      value = this.ruleValue;
	    }
	
	    return value;
	  },
	
	  /**
	   * Get true size of value
	   *
	   * @return {integer|float}
	   */
	  getSize: function() {
	    var value = this.inputValue;
	
	    if (value instanceof Array) {
	      return value.length;
	    }
	
	    if (typeof value === 'number') {
	      return value;
	    }
	
	    if (this.validator._hasNumericRule(this.attribute)) {
	      return parseFloat(value, 10);
	    }
	
	    return value.length;
	  },
	
	  /**
	   * Get the type of value being checked; numeric or string.
	   *
	   * @return {string}
	   */
	  _getValueType: function() {
	
	    if (typeof this.inputValue === 'number' || this.validator._hasNumericRule(this.attribute)) {
	      return 'numeric';
	    }
	
	    return 'string';
	  },
	
	  /**
	   * Set the async callback response
	   *
	   * @param  {boolean|undefined} passes  Whether validation passed
	   * @param  {string|undefined} message Custom error message
	   * @return {void}
	   */
	  response: function(passes, message) {
	    this.passes = (passes === undefined || passes === true);
	    this._customMessage = message;
	    this.callback(this.passes, message);
	  },
	
	  /**
	   * Set validator instance
	   *
	   * @param {Validator} validator
	   * @return {void}
	   */
	  setValidator: function(validator) {
	    this.validator = validator;
	  },
	
	  /**
	   * Check if rule is missed
	   *
	   * @return {boolean}
	   */
	  isMissed: function() {
	    return typeof this.fn !== 'function';
	  },
	
	  get customMessage() {
	    return this.isMissed() ? missedRuleMessage : this._customMessage;
	  }
	};
	
	var manager = {
	
	  /**
	   * List of async rule names
	   *
	   * @type {Array}
	   */
	  asyncRules: [],
	
	  /**
	   * Implicit rules (rules to always validate)
	   *
	   * @type {Array}
	   */
	  implicitRules: ['required', 'required_if', 'required_unless', 'required_with', 'required_with_all', 'required_without', 'required_without_all', 'accepted', 'present'],
	
	  /**
	   * Get rule by name
	   *
	   * @param  {string} name
	   * @param {Validator}
	   * @return {Rule}
	   */
	  make: function(name, validator) {
	    var async = this.isAsync(name);
	    var rule = new Rule(name, rules[name], async);
	    rule.setValidator(validator);
	    return rule;
	  },
	
	  /**
	   * Determine if given rule is async
	   *
	   * @param  {string}  name
	   * @return {boolean}
	   */
	  isAsync: function(name) {
	    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
	      if (this.asyncRules[i] === name) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Determine if rule is implicit (should always validate)
	   *
	   * @param {string} name
	   * @return {boolean}
	   */
	  isImplicit: function(name) {
	    return this.implicitRules.indexOf(name) > -1;
	  },
	
	  /**
	   * Register new rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  register: function(name, fn) {
	    rules[name] = fn;
	  },
	
	    /**
	   * Register new implicit rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerImplicit: function(name, fn) {
	    this.register(name, fn);
	    this.implicitRules.push(name);
	  },
	
	  /**
	   * Register async rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerAsync: function(name, fn) {
	    this.register(name, fn);
	    this.asyncRules.push(name);
	  },
	
	  /**
	   * Register implicit async rule
	   *
	   * @param  {string}   name
	   * @param  {function} fn
	   * @return {void}
	   */
	  registerAsyncImplicit: function(name, fn) {
	    this.registerImplicit(name, fn);
	    this.asyncRules.push(name);
	  },
	
	  registerMissedRuleValidator: function(fn, message) {
	    missedRuleValidator = fn;
	    missedRuleMessage = message;
	  }
	};
	
	
	
	module.exports = manager;


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	var Rules = __webpack_require__(622);
	var Lang = __webpack_require__(620);
	var Errors = __webpack_require__(618);
	var Attributes = __webpack_require__(272);
	var AsyncResolvers = __webpack_require__(617);
	
	var Validator = function (input, rules, customMessages) {
	  var lang = Validator.getDefaultLang();
	  this.input = input || {};
	
	  this.messages = Lang._make(lang);
	  this.messages._setCustom(customMessages);
	  this.setAttributeFormatter(Validator.prototype.attributeFormatter);
	
	  this.errors = new Errors();
	  this.errorCount = 0;
	
	  this.hasAsync = false;
	  this.rules = this._parseRules(rules);
	};
	
	Validator.prototype = {
	
	  constructor: Validator,
	
	  /**
	   * Default language
	   *
	   * @type {string}
	   */
	  lang: 'en',
	
	  /**
	   * Numeric based rules
	   *
	   * @type {array}
	   */
	  numericRules: ['integer', 'numeric'],
	
	  /**
	   * Attribute formatter.
	   *
	   * @type {function}
	   */
	  attributeFormatter: Attributes.formatter,
	
	  /**
	   * Run validator
	   *
	   * @return {boolean} Whether it passes; true = passes, false = fails
	   */
	  check: function () {
	    var self = this;
	
	    for (var attribute in this.rules) {
	      var attributeRules = this.rules[attribute];
	      var inputValue = this._objectPath(this.input, attribute);
	
	      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	        continue;
	      }
	
	      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
	        ruleOptions = attributeRules[i];
	        rule = this.getRule(ruleOptions.name);
	
	        if (!this._isValidatable(rule, inputValue)) {
	          continue;
	        }
	
	        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
	        if (!rulePassed) {
	          this._addFailure(rule);
	        }
	
	        if (this._shouldStopValidating(attribute, rulePassed)) {
	          break;
	        }
	      }
	    }
	
	    return this.errorCount === 0;
	  },
	
	  /**
	   * Run async validator
	   *
	   * @param {function} passes
	   * @param {function} fails
	   * @return {void}
	   */
	  checkAsync: function (passes, fails) {
	    var _this = this;
	    passes = passes || function () {};
	    fails = fails || function () {};
	
	    var failsOne = function (rule, message) {
	      _this._addFailure(rule, message);
	    };
	
	    var resolvedAll = function (allPassed) {
	      if (allPassed) {
	        passes();
	      } else {
	        fails();
	      }
	    };
	
	    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);
	
	    var validateRule = function (inputValue, ruleOptions, attribute, rule) {
	      return function () {
	        var resolverIndex = asyncResolvers.add(rule);
	        rule.validate(inputValue, ruleOptions.value, attribute, function () {
	          asyncResolvers.resolve(resolverIndex);
	        });
	      };
	    };
	
	    for (var attribute in this.rules) {
	      var attributeRules = this.rules[attribute];
	      var inputValue = this._objectPath(this.input, attribute);
	
	      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
	        continue;
	      }
	
	      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
	        ruleOptions = attributeRules[i];
	
	        rule = this.getRule(ruleOptions.name);
	
	        if (!this._isValidatable(rule, inputValue)) {
	          continue;
	        }
	
	        validateRule(inputValue, ruleOptions, attribute, rule)();
	      }
	    }
	
	    asyncResolvers.enableFiring();
	    asyncResolvers.fire();
	  },
	
	  /**
	   * Add failure and error message for given rule
	   *
	   * @param {Rule} rule
	   */
	  _addFailure: function (rule) {
	    var msg = this.messages.render(rule);
	    this.errors.add(rule.attribute, msg);
	    this.errorCount++;
	  },
	
	  /**
	   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
	   *
	   * @param  {object} nested object
	   * @return {object} flattened object
	   */
	  _flattenObject: function (obj) {
	    var flattened = {};
	
	    function recurse(current, property) {
	      if (!property && Object.getOwnPropertyNames(current).length === 0) {
	        return;
	      }
	      if (Object(current) !== current || Array.isArray(current)) {
	        flattened[property] = current;
	      } else {
	        var isEmpty = true;
	        for (var p in current) {
	          isEmpty = false;
	          recurse(current[p], property ? property + "." + p : p);
	        }
	        if (isEmpty) {
	          flattened[property] = {};
	        }
	      }
	    }
	    if (obj) {
	      recurse(obj);
	    }
	    return flattened;
	  },
	
	  /**
	   * Extract value from nested object using string path with dot notation
	   *
	   * @param  {object} object to search in
	   * @param  {string} path inside object
	   * @return {any|void} value under the path
	   */
	  _objectPath: function (obj, path) {
	    if (Object.prototype.hasOwnProperty.call(obj, path)) {
	      return obj[path];
	    }
	
	    var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
	    var copy = {};
	    for (var attr in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
	        copy[attr] = obj[attr];
	      }
	    }
	
	    for (var i = 0, l = keys.length; i < l; i++) {
	      if (Object.hasOwnProperty.call(copy, keys[i])) {
	        copy = copy[keys[i]];
	      } else {
	        return;
	      }
	    }
	    return copy;
	  },
	
	  /**
	   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
	   *
	   * @param  {object} rules
	   * @return {object}
	   */
	  _parseRules: function (rules) {
	
	    var parsedRules = {};
	    rules = this._flattenObject(rules);
	
	    for (var attribute in rules) {
	
	      var rulesArray = rules[attribute];
	
	      this._parseRulesCheck(attribute, rulesArray, parsedRules);
	    }
	    return parsedRules;
	
	
	  },
	
	  _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    if (attribute.indexOf('*') > -1) {
	      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
	    } else {
	      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
	    }
	  },
	
	  _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);
	    var propertyValue = this._objectPath(this.input, parentPath);
	
	    if (propertyValue) {
	      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
	        var workingValues = wildCardValues ? wildCardValues.slice() : [];
	        workingValues.push(propertyNumber);
	        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
	      }
	    }
	  },
	
	  _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
	    var attributeRules = [];
	
	    if (rulesArray instanceof Array) {
	      rulesArray = this._prepareRulesArray(rulesArray);
	    }
	
	    if (typeof rulesArray === 'string') {
	      rulesArray = rulesArray.split('|');
	    }
	
	    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
	      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
	      if (rule.value) {
	        rule.value = this._replaceWildCards(rule.value, wildCardValues);
	        this._replaceWildCardsMessages(wildCardValues);
	      }
	
	      if (Rules.isAsync(rule.name)) {
	        this.hasAsync = true;
	      }
	      attributeRules.push(rule);
	    }
	
	    parsedRules[attribute] = attributeRules;
	  },
	
	  _replaceWildCards: function (path, nums) {
	
	    if (!nums) {
	      return path;
	    }
	
	    var path2 = path;
	    nums.forEach(function (value) {
	      var pos = path2.indexOf('*');
	      if (pos === -1) {
	        return path2;
	      }
	      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
	    });
	    return path2;
	  },
	
	  _replaceWildCardsMessages: function (nums) {
	    var customMessages = this.messages.customMessages;
	    var self = this;
	    Object.keys(customMessages).forEach(function (key) {
	      if (nums) {
	        var newKey = self._replaceWildCards(key, nums);
	        customMessages[newKey] = customMessages[key];
	      }
	    });
	
	    this.messages._setCustom(customMessages);
	  },
	  /**
	   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
	   *
	   * @param  {array} rulesArray
	   * @return {array}
	   */
	  _prepareRulesArray: function (rulesArray) {
	    var rules = [];
	
	    for (var i = 0, len = rulesArray.length; i < len; i++) {
	      if (typeof rulesArray[i] === 'object') {
	        for (var rule in rulesArray[i]) {
	          rules.push({
	            name: rule,
	            value: rulesArray[i][rule]
	          });
	        }
	      } else {
	        rules.push(rulesArray[i]);
	      }
	    }
	
	    return rules;
	  },
	
	  /**
	   * Determines if the attribute is supplied with the original data object.
	   *
	   * @param  {array} attribute
	   * @return {boolean}
	   */
	  _suppliedWithData: function (attribute) {
	    return this.input.hasOwnProperty(attribute);
	  },
	
	  /**
	   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
	   *
	   * @param  {string} ruleString min:3
	   * @return {object} object containing the name of the rule and value
	   */
	  _extractRuleAndRuleValue: function (ruleString) {
	    var rule = {},
	      ruleArray;
	
	    rule.name = ruleString;
	
	    if (ruleString.indexOf(':') >= 0) {
	      ruleArray = ruleString.split(':');
	      rule.name = ruleArray[0];
	      rule.value = ruleArray.slice(1).join(":");
	    }
	
	    return rule;
	  },
	
	  /**
	   * Determine if attribute has any of the given rules
	   *
	   * @param  {string}  attribute
	   * @param  {array}   findRules
	   * @return {boolean}
	   */
	  _hasRule: function (attribute, findRules) {
	    var rules = this.rules[attribute] || [];
	    for (var i = 0, len = rules.length; i < len; i++) {
	      if (findRules.indexOf(rules[i].name) > -1) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Determine if attribute has any numeric-based rules.
	   *
	   * @param  {string}  attribute
	   * @return {Boolean}
	   */
	  _hasNumericRule: function (attribute) {
	    return this._hasRule(attribute, this.numericRules);
	  },
	
	  /**
	   * Determine if rule is validatable
	   *
	   * @param  {Rule}   rule
	   * @param  {mixed}  value
	   * @return {boolean}
	   */
	  _isValidatable: function (rule, value) {
	    if (Rules.isImplicit(rule.name)) {
	      return true;
	    }
	
	    return this.getRule('required').validate(value);
	  },
	
	  /**
	   * Determine if we should stop validating.
	   *
	   * @param  {string} attribute
	   * @param  {boolean} rulePassed
	   * @return {boolean}
	   */
	  _shouldStopValidating: function (attribute, rulePassed) {
	
	    var stopOnAttributes = this.stopOnAttributes;
	    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
	      return false;
	    }
	
	    if (stopOnAttributes instanceof Array) {
	      return stopOnAttributes.indexOf(attribute) > -1;
	    }
	
	    return true;
	  },
	
	  /**
	   * Set custom attribute names.
	   *
	   * @param {object} attributes
	   * @return {void}
	   */
	  setAttributeNames: function (attributes) {
	    this.messages._setAttributeNames(attributes);
	  },
	
	  /**
	   * Set the attribute formatter.
	   *
	   * @param {fuction} func
	   * @return {void}
	   */
	  setAttributeFormatter: function (func) {
	    this.messages._setAttributeFormatter(func);
	  },
	
	  /**
	   * Get validation rule
	   *
	   * @param  {string} name
	   * @return {Rule}
	   */
	  getRule: function (name) {
	    return Rules.make(name, this);
	  },
	
	  /**
	   * Stop on first error.
	   *
	   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	   * @return {void}
	   */
	  stopOnError: function (attributes) {
	    this.stopOnAttributes = attributes;
	  },
	
	  /**
	   * Determine if validation passes
	   *
	   * @param {function} passes
	   * @return {boolean|undefined}
	   */
	  passes: function (passes) {
	    var async = this._checkAsync('passes', passes);
	    if (async) {
	      return this.checkAsync(passes);
	    }
	    return this.check();
	  },
	
	  /**
	   * Determine if validation fails
	   *
	   * @param {function} fails
	   * @return {boolean|undefined}
	   */
	  fails: function (fails) {
	    var async = this._checkAsync('fails', fails);
	    if (async) {
	      return this.checkAsync(function () {}, fails);
	    }
	    return !this.check();
	  },
	
	  /**
	   * Check if validation should be called asynchronously
	   *
	   * @param  {string}   funcName Name of the caller
	   * @param  {function} callback
	   * @return {boolean}
	   */
	  _checkAsync: function (funcName, callback) {
	    var hasCallback = typeof callback === 'function';
	    if (this.hasAsync && !hasCallback) {
	      throw funcName + ' expects a callback when async rules are being tested.';
	    }
	
	    return this.hasAsync || hasCallback;
	  }
	
	};
	
	/**
	 * Set messages for language
	 *
	 * @param {string} lang
	 * @param {object} messages
	 * @return {this}
	 */
	Validator.setMessages = function (lang, messages) {
	  Lang._set(lang, messages);
	  return this;
	};
	
	/**
	 * Get messages for given language
	 *
	 * @param  {string} lang
	 * @return {Messages}
	 */
	Validator.getMessages = function (lang) {
	  return Lang._get(lang);
	};
	
	/**
	 * Set default language to use
	 *
	 * @param {string} lang
	 * @return {void}
	 */
	Validator.useLang = function (lang) {
	  this.prototype.lang = lang;
	};
	
	/**
	 * Get default language
	 *
	 * @return {string}
	 */
	Validator.getDefaultLang = function () {
	  return this.prototype.lang;
	};
	
	/**
	 * Set the attribute formatter.
	 *
	 * @param {fuction} func
	 * @return {void}
	 */
	Validator.setAttributeFormatter = function (func) {
	  this.prototype.attributeFormatter = func;
	};
	
	/**
	 * Stop on first error.
	 *
	 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
	 * @return {void}
	 */
	Validator.stopOnError = function (attributes) {
	  this.prototype.stopOnAttributes = attributes;
	};
	
	/**
	 * Register custom validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */
	Validator.register = function (name, fn, message) {
	  var lang = Validator.getDefaultLang();
	  Rules.register(name, fn);
	  Lang._setRuleMessage(lang, name, message);
	};
	
	/**
	 * Register custom validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */
	Validator.registerImplicit = function (name, fn, message) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerImplicit(name, fn);
	  Lang._setRuleMessage(lang, name, message);
	};
	
	/**
	 * Register asynchronous validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */
	Validator.registerAsync = function (name, fn, message) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerAsync(name, fn);
	  Lang._setRuleMessage(lang, name, message);
	};
	
	/**
	 * Register asynchronous validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */
	Validator.registerAsyncImplicit = function (name, fn, message) {
	  var lang = Validator.getDefaultLang();
	  Rules.registerAsyncImplicit(name, fn);
	  Lang._setRuleMessage(lang, name, message);
	};
	
	/**
	 * Register validator for missed validation rule
	 *
	 * @param  {string}   name
	 * @param  {function} fn
	 * @param  {string}   message
	 * @return {void}
	 */
	Validator.registerMissedRuleValidator = function(fn, message) {
	  Rules.registerMissedRuleValidator(fn, message);
	};
	
	module.exports = Validator;


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  line-height: 1;\n\n  &:first-child {\n    margin-right: 8px;\n  }\n\n  &:last-child {\n    margin-left: 8px;\n  }\n'], ['\n  line-height: 1;\n\n  &:first-child {\n    margin-right: 8px;\n  }\n\n  &:last-child {\n    margin-left: 8px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  0% {\n    opacity: 0.4;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.4;\n  }\n'], ['\n  0% {\n    opacity: 0.4;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.4;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  padding: 0;\n  padding-left: 24px;\n  padding-right: 24px;\n  border-radius: 4px;\n  height: ', 'px;\n  line-height: ', 'px;\n  border: 1px solid ', ';\n  text-transform: uppercase;\n  background: transparent;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ';\n  outline: 0;\n  transition: 0.2s all ease;  \n\n  :focus {\n    box-shadow: 0 0 0 2px ', '\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ', '\n\n  ', ';\n\n  ', ';\n\n  ', '\n'], ['\n  display: inline-block;\n  padding: 0;\n  padding-left: 24px;\n  padding-right: 24px;\n  border-radius: 4px;\n  height: ', 'px;\n  line-height: ', 'px;\n  border: 1px solid ', ';\n  text-transform: uppercase;\n  background: transparent;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ';\n  outline: 0;\n  transition: 0.2s all ease;  \n\n  :focus {\n    box-shadow: 0 0 0 2px ', '\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ', '\n\n  ', ';\n\n  ', ';\n\n  ', '\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    animation: ', ' 2s linear infinite;\n  '], ['\n    animation: ', ' 2s linear infinite;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n      ', ':first-child {\n        margin-right: 24px;\n      }\n\n      ', ':last-child {\n        margin-left: 48px;\n      }\n    '], ['\n      ', ':first-child {\n        margin-right: 24px;\n      }\n\n      ', ':last-child {\n        margin-left: 48px;\n      }\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n      color: ', ';\n      border-color: ', ';\n    '], ['\n      color: ', ';\n      border-color: ', ';\n    ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    height: ', 'px\n    line-height: ', 'px\n  '], ['\n    height: ', 'px\n    line-height: ', 'px\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(7);
	
	var _variables2 = _interopRequireDefault(_variables);
	
	var _gatsbyLink = __webpack_require__(76);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var component = _ref.component,
	      spacious = _ref.spacious,
	      preset = _ref.preset,
	      size = _ref.size,
	      loading = _ref.loading,
	      disabled = _ref.disabled,
	      title = _ref.title,
	      props = _objectWithoutProperties(_ref, ['component', 'spacious', 'preset', 'size', 'loading', 'disabled', 'title']);
	
	  var Component = component === 'a' ? _gatsbyLink2.default : component;
	  return _react2.default.createElement(Component, _extends({}, props, { disabled: loading || disabled, title: loading ? 'Loading...' : title }));
	};
	
	Button.defaultProps = {
	  preset: 'primary',
	  size: 'medium',
	  component: 'button'
	};
	
	Button.IconContainer = _styledComponents2.default.div(_templateObject);
	
	Button.Icon = _styledComponents2.default.div(_templateObject2);
	
	Button.IconText = function (_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    'span',
	    null,
	    children
	  );
	};
	
	var loading = (0, _styledComponents.keyframes)(_templateObject3);
	
	exports.default = (0, _styledComponents2.default)(Button)(_templateObject4, _variables2.default['form-size'], _variables2.default['form-size'] - 1, _variables2.default['color-primary'], _variables2.default['color-primary'], _variables2.default['color-gray'], function (props) {
	  return props.loading && (0, _styledComponents.css)(_templateObject5, loading);
	}, function (props) {
	  return props.spacious && (0, _styledComponents.css)(_templateObject6, Button.Icon, Button.Icon);
	}, function (props) {
	  return props.preset === 'gray' && (0, _styledComponents.css)(_templateObject7, _variables2.default['color-dark-gray'], _variables2.default['color-dark-gray']);
	}, function (props) {
	  return props.size === 'large' && (0, _styledComponents.css)(_templateObject8, _variables2.default['form-size-large'], _variables2.default['form-size-large'] - 1);
	});
	module.exports = exports['default'];

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  background: #fff;\n  height: auto;\n  padding: 14px 16px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  font-size: 18px;\n  transition: 0.2s all ease;\n  outline: 0;\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n  }\n'], ['\n  display: block;\n  width: 100%;\n  background: #fff;\n  height: auto;\n  padding: 14px 16px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  font-size: 18px;\n  transition: 0.2s all ease;\n  outline: 0;\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n  }\n']);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(7);
	
	var _variables2 = _interopRequireDefault(_variables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Input = _styledComponents2.default.input(_templateObject, _variables2.default['color-gray'], _variables2.default['color-blue']);
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    color: red;\n    font-size: 12px;\n    margin-top: 4px;\n    transition: 0.3s all ease;\n\n    ', '\n\n    ', '\n  '], ['\n    color: red;\n    font-size: 12px;\n    margin-top: 4px;\n    transition: 0.3s all ease;\n\n    ', '\n\n    ', '\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n      opacity: 0;\n      transform: translateY(-16px);\n    '], ['\n      opacity: 0;\n      transform: translateY(-16px);\n    ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      opacity: 1;\n      transform: translateY(0);\n    '], ['\n      opacity: 1;\n      transform: translateY(0);\n    ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ui = {
	  InputError: (0, _styledComponents2.default)(function (_ref) {
	    var hidden = _ref.hidden,
	        props = _objectWithoutProperties(_ref, ['hidden']);
	
	    return _react2.default.createElement('div', props);
	  })(_templateObject, function (props) {
	    return props.hidden && (0, _styledComponents.css)(_templateObject2);
	  }, function (props) {
	    return !props.hidden && (0, _styledComponents.css)(_templateObject3);
	  })
	};
	
	var InputError = function (_React$Component) {
	  _inherits(InputError, _React$Component);
	
	  function InputError() {
	    _classCallCheck(this, InputError);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  InputError.prototype.render = function render() {
	    var error = this.props.errors ? this.props.errors[0] : '';
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.children,
	      _react2.default.createElement(
	        ui.InputError,
	        { hidden: !error },
	        error
	      )
	    );
	  };
	
	  return InputError;
	}(_react2.default.Component);
	
	exports.default = InputError;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LastLocationProvider = exports.withLastLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(61);
	
	var _createReactContext = __webpack_require__(75);
	
	var _createReactContext2 = _interopRequireDefault(_createReactContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Context = (0, _createReactContext2.default)();
	
	var LastLocationProvider = function (_React$Component) {
	  _inherits(LastLocationProvider, _React$Component);
	
	  function LastLocationProvider() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LastLocationProvider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      location: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LastLocationProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    console.log('hehe', nextProps);
	
	    if (this.state.location !== nextProps.location) {
	      this.setState({
	        location: this.props.location
	      });
	    }
	  };
	
	  LastLocationProvider.prototype.render = function render() {
	    return _react2.default.createElement(
	      Context.Provider,
	      { value: this.state.location },
	      this.props.children
	    );
	  };
	
	  return LastLocationProvider;
	}(_react2.default.Component);
	
	var LastLocationProviderWithRouter = (0, _reactRouter.withRouter)(LastLocationProvider);
	
	function withLastLocation(Component) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_React$Component2) {
	    _inherits(_class, _React$Component2);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        Context.Consumer,
	        null,
	        function (location) {
	          return _react2.default.createElement(Component, _extends({}, _this3.props, { lastLocation: location }));
	        }
	      );
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.displayName = 'withLastLocation(' + Component.displayName + ')', _temp2;
	}
	
	exports.withLastLocation = withLastLocation;
	exports.LastLocationProvider = LastLocationProviderWithRouter;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  min-height: 100vh;\n'], ['\n  background-color: ', ';\n  min-height: 100vh;\n']);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(7);
	
	var _variables2 = _interopRequireDefault(_variables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Background = _styledComponents2.default.div(_templateObject, _variables2.default['color-silver']);
	
	exports.default = Background;
	module.exports = exports['default'];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouter = __webpack_require__(61);
	
	var _config = __webpack_require__(24);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageHelmet = function (_React$Component) {
	  _inherits(PageHelmet, _React$Component);
	
	  function PageHelmet() {
	    _classCallCheck(this, PageHelmet);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHelmet.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        description = _props.description;
	
	    return _react2.default.createElement(_reactHelmet2.default, {
	      title: title,
	      meta: [{ property: 'og:url', content: 'https://techbrewlabs.com' + this.props.location.pathname }, { name: 'title', content: _config2.default.title + ' | ' + title }, { property: 'og:title', content: _config2.default.title + ' | ' + title }, { name: 'description', content: description }, { property: 'og:description', content: description }, { property: 'twitter:card', content: description }]
	    });
	  };
	
	  return PageHelmet;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(PageHelmet);
	module.exports = exports['default'];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  background: #fff;\n  padding: 14px 16px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  font-size: 18px;\n  transition: 0.2s all ease;\n  outline: 0;\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n  }\n'], ['\n  display: block;\n  width: 100%;\n  background: #fff;\n  padding: 14px 16px;\n  border: 1px solid ', ';\n  border-radius: 4px;\n  font-size: 18px;\n  transition: 0.2s all ease;\n  outline: 0;\n\n  &:hover,\n  &:focus {\n    border-color: ', ';\n  }\n']);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _variables = __webpack_require__(7);
	
	var _variables2 = _interopRequireDefault(_variables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Textarea = _styledComponents2.default.textarea(_templateObject, _variables2.default['color-gray'], _variables2.default['color-blue']);
	
	exports.default = Textarea;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  title: 'Tech Brew Labs',
	  keyline: 'We turn ideas into life',
	  description: 'We are a development studio focused on delivering quality software and interactive user experiences.',
	  email: 'hey@techbrewlabs.com',
	  keywords: ['laravel', 'php', 'philippines', 'react.js', 'react', 'vue', 'remote', 'freelance', 'digital agency', 'ui', 'ux', 'programming', 'javascript']
	};
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainBackground = __webpack_require__(65);
	
	var _MainBackground2 = _interopRequireDefault(_MainBackground);
	
	var _LastLocation = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseLayout = function BaseLayout(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    _LastLocation.LastLocationProvider,
	    null,
	    _react2.default.createElement(
	      _MainBackground2.default,
	      null,
	      children
	    )
	  );
	};
	
	exports.default = BaseLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding-top: 40px;\n    padding-bottom: 120px;\n  '], ['\n    padding-top: 40px;\n    padding-bottom: 120px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    margin-bottom: 40px;\n  '], ['\n    margin-bottom: 40px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    margin-bottom: 32px;\n  '], ['\n    margin-bottom: 32px;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    margin-bottom: 16px;\n    &:first-child {\n      margin-right: 8px;\n    }\n\n    &:last-child {\n      margin-left: 8px;\n    }\n  '], ['\n    width: 100%;\n    margin-bottom: 16px;\n    &:first-child {\n      margin-right: 8px;\n    }\n\n    &:last-child {\n      margin-left: 8px;\n    }\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    text-align: right;\n  '], ['\n    text-align: right;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    margin: 0;\n    padding-top: 120px;\n    font-size: 56px;\n    font-family: ', ';\n    text-align: center;\n  '], ['\n    margin: 0;\n    padding-top: 120px;\n    font-size: 56px;\n    font-family: ', ';\n    text-align: center;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Jumbotron = __webpack_require__(20);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	var _Container = __webpack_require__(11);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Base = __webpack_require__(67);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	var _Button = __webpack_require__(64);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(317);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _InputError = __webpack_require__(318);
	
	var _InputError2 = _interopRequireDefault(_InputError);
	
	var _Textarea = __webpack_require__(320);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _FA = __webpack_require__(44);
	
	var _FA2 = _interopRequireDefault(_FA);
	
	var _variables = __webpack_require__(7);
	
	var _variables2 = _interopRequireDefault(_variables);
	
	var _PageHelmet = __webpack_require__(66);
	
	var _PageHelmet2 = _interopRequireDefault(_PageHelmet);
	
	var _LastLocation = __webpack_require__(45);
	
	var _linkstate = __webpack_require__(465);
	
	var _linkstate2 = _interopRequireDefault(_linkstate);
	
	var _axios = __webpack_require__(292);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _validatorjs = __webpack_require__(623);
	
	var _validatorjs2 = _interopRequireDefault(_validatorjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ui = {
	  Wrapper: _styledComponents2.default.div(_templateObject),
	  CloseButton: _styledComponents2.default.div(_templateObject2),
	  FormFields: _styledComponents2.default.div(_templateObject3),
	  FormFieldsInfo: _styledComponents2.default.div(_templateObject4),
	  FormFieldsInfoSection: _styledComponents2.default.div(_templateObject5),
	  FormAction: _styledComponents2.default.div(_templateObject6),
	  Success: _styledComponents2.default.h1(_templateObject7, _variables2.default['font-family-heading-serif'])
	};
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      email: '',
	      subject: '',
	      body: '',
	      error: '',
	      loading: false,
	      success: false,
	      errors: {}
	    }, _this.handleClose = function () {
	      if (_this.props.lastLocation) {
	        _this.props.history.goBack();
	      } else {
	        _this.props.history.push('/');
	      }
	    }, _this.format = function () {
	      return {
	        content: _this.state.name + ' (' + _this.state.email + ') sent: ' + ('```' + _this.state.body + '```')
	      };
	    }, _this.handleSubmit = function (evt) {
	      evt.preventDefault();
	
	      if (_this.state.loading) {
	        return;
	      }
	
	      var v = new _validatorjs2.default({
	        name: _this.state.name,
	        email: _this.state.email,
	        body: _this.state.body
	      }, {
	        name: 'required',
	        email: 'email|required',
	        body: 'required'
	      });
	
	      if (v.fails()) {
	        _this.setState({
	          errors: v.errors.all(),
	          error: 'Please fill out the form properly.'
	        });
	
	        return;
	      }
	
	      _this.setState({
	        loading: true
	      });
	
	      _axios2.default.post(("https://discordapp.com/api/webhooks/466663153057660928/tUKv-0n1A95My8yLiih1h1aGc8puAMCQixpYSsA4M6a36s_zB7jwh2BQlywy3P4yqu8i"), _this.format()).then(function (res) {
	        _this.setState({
	          loading: false,
	          success: true
	        });
	      }, function (err) {
	        _this.setState({
	          error: 'An error occurred. Please try again!',
	          loading: false
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_PageHelmet2.default, {
	        title: 'Contact Us',
	        description: 'Send business inquires or just drop by to say hi!'
	      }),
	      _react2.default.createElement(
	        ui.Wrapper,
	        null,
	        _react2.default.createElement(
	          ui.CloseButton,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: this.handleClose,
	              disabled: this.state.loading
	            },
	            _react2.default.createElement(
	              _Button2.default.IconContainer,
	              null,
	              _react2.default.createElement(
	                _Button2.default.Icon,
	                null,
	                _react2.default.createElement(_FA2.default, { icon: 'times' })
	              ),
	              _react2.default.createElement(
	                _Button2.default.IconText,
	                null,
	                'Close'
	              )
	            )
	          )
	        ),
	        this.state.success && _react2.default.createElement(_Jumbotron2.default, {
	          headline: 'Arigathanks!',
	          title: 'We\'ll be in touch.',
	          alignment: 'center'
	        }),
	        !this.state.success && _react2.default.createElement(_Jumbotron2.default, {
	          headline: 'Reach out',
	          title: 'Let\'s create something together!'
	        }),
	        !this.state.success && this.state.error && _react2.default.createElement(
	          'p',
	          null,
	          this.state.error
	        ),
	        !this.state.success && _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            ui.FormFields,
	            null,
	            _react2.default.createElement(
	              ui.FormFieldsInfo,
	              null,
	              _react2.default.createElement(
	                ui.FormFieldsInfoSection,
	                null,
	                _react2.default.createElement(
	                  _InputError2.default,
	                  { errors: this.state.errors.name },
	                  _react2.default.createElement(_Input2.default, {
	                    placeholder: 'Your name',
	                    onChange: (0, _linkstate2.default)(this, 'name'),
	                    value: this.state.name
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                ui.FormFieldsInfoSection,
	                null,
	                _react2.default.createElement(
	                  _InputError2.default,
	                  { errors: this.state.errors.email },
	                  _react2.default.createElement(_Input2.default, {
	                    placeholder: 'Your email',
	                    type: 'email',
	                    onChange: (0, _linkstate2.default)(this, 'email'),
	                    value: this.state.email
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _InputError2.default,
	              { errors: this.state.errors.body },
	              _react2.default.createElement(_Textarea2.default, {
	                rows: '8',
	                placeholder: 'Your message...',
	                onChange: (0, _linkstate2.default)(this, 'body'),
	                value: this.state.body
	              })
	            )
	          ),
	          _react2.default.createElement(
	            ui.FormAction,
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                loading: this.state.loading,
	                spacious: true,
	                size: 'large'
	              },
	              _react2.default.createElement(
	                _Button2.default.IconContainer,
	                null,
	                _react2.default.createElement(
	                  _Button2.default.IconText,
	                  null,
	                  'Send Message'
	                ),
	                _react2.default.createElement(
	                  _Button2.default.Icon,
	                  null,
	                  _react2.default.createElement(_FA2.default, { icon: 'long-arrow-alt-right', size: '2x' })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	var ContactPageWithLastLocation = (0, _LastLocation.withLastLocation)(ContactPage);
	
	var ContactPageWithLayout = function ContactPageWithLayout(props) {
	  return _react2.default.createElement(
	    _Base2.default,
	    props,
	    _react2.default.createElement(ContactPageWithLastLocation, props)
	  );
	};
	
	exports.default = ContactPageWithLayout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-379b69482711806bbc6d.js